/* src/app/front-layout/uae/uae.component.css */
.hero-section {
  position: relative;
  height: 100vh;
  background: url(/assets/images/uae-hero-new.png) center center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 146, 132, 0.7);
}
.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 1200px;
  padding: 0 20px;
}
.hero-title {
  font-size: 55px;
  font-weight: 600;
  color: white;
  line-height: 1.3;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}
.hero-subtitle {
  font-size: 24px;
  line-height: 1.6;
  margin-bottom: 30px;
  font-weight: 500;
}
.btn-book-demo {
  background: #FFC629;
  color: white;
  border: none;
  padding: 15px 40px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 165, 0, 0.4);
}
.btn-book-demo:hover {
  background: #FF8C00;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 165, 0, 0.5);
}
.hero-links {
  margin-top: 25px;
  font-size: 14px;
}
.hero-link {
  color: white;
  text-decoration: none;
  transition: opacity 0.3s ease;
  cursor: pointer;
}
.hero-link:hover {
  opacity: 0.8;
}
.separator {
  margin: 0 15px;
  opacity: 0.7;
}
.why-choose-section {
  padding: 80px 0;
  background: white;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.content-wrapper {
  display: flex;
  gap: 60px;
  align-items: center;
}
.left-content {
  flex: 1;
}
.right-content {
  flex: 1;
}
.section-title {
  color: #059d98;
  font-size: 42px;
  font-weight: 600;
  margin-bottom: 10px;
}
.section-subtitle {
  color: #666;
  font-size: 16px;
  margin-bottom: 40px;
}
.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}
.feature-item {
  display: flex;
  flex-direction: column;
}
.feature-number {
  color: #059d98;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 10px;
}
.feature-title {
  color: #333;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
}
.image-wrapper {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
.feature-image {
  width: 100%;
  height: auto;
  display: block;
}
.about-section {
  padding: 80px 0;
  background: #059d98;
  color: white;
}
.about-title {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 10px;
  color: white;
}
.about-subtitle {
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 40px;
}
.about-content {
  max-width: 900px;
}
.about-text {
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 20px;
  opacity: 0.95;
}
.mission-section {
  padding: 80px 0;
  background: white;
  border-top: 3px solid #059d98;
}
.mission-wrapper {
  display: flex;
  gap: 60px;
  align-items: center;
}
.mission-image {
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
.mission-img {
  width: 100%;
  height: 300px;
  display: block;
  object-fit: cover;
}
.mission-content {
  flex: 1;
}
.mission-title {
  color: #059d98;
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 20px;
}
.mission-text {
  color: #333;
  font-size: 18px;
  line-height: 1.8;
}
.values-section {
  padding: 80px 0;
  background: white;
}
.values-wrapper {
  display: flex;
  gap: 60px;
  align-items: center;
}
.values-content {
  flex: 1;
}
.values-image {
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
.values-img {
  width: 100%;
  height: 400px;
  object-fit: cover;
  display: block;
}
.values-title {
  color: #059d98;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 30px;
}
.values-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.value-item {
  display: flex;
  gap: 15px;
  align-items: flex-start;
}
.value-icon {
  font-size: 32px;
  flex-shrink: 0;
}
.value-details {
  color: #333;
  font-size: 16px;
  line-height: 1.6;
}
.value-details strong {
  color: #000;
  font-weight: 600;
}
.courses-section {
  padding: 80px 0;
  background: #FFC629;
}
.courses-title {
  color: #059d98;
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 10px;
}
.courses-subtitle {
  color: #000;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}
.courses-description {
  color: #333;
  font-size: 16px;
  margin-bottom: 25px;
}
.btn-book-free-demo {
  background: #059d98;
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 40px;
}
.btn-book-free-demo:hover {
  background: #059d98;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 153, 255, 0.4);
}
.courses-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}
.course-card {
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.course-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}
.course-icon {
  margin-bottom: 20px;
}
.course-title {
  color: #000;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 15px;
}
.course-subjects {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}
.learning-fits-section {
  padding: 80px 0;
  background: white;
  border-top: 3px solid #FFC629;
}
.learning-wrapper {
  display: flex;
  gap: 60px;
  align-items: center;
}
.learning-content {
  flex: 1;
}
.learning-image {
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
.learning-img {
  width: 100%;
  height: 500px;
  display: block;
}
.learning-title {
  color: #059d98;
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 10px;
}
.learning-subtitle {
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
}
.learning-steps {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 30px;
}
.step-item {
  color: #333;
  font-size: 15px;
  line-height: 1.6;
  padding-left: 10px;
  border-left: 3px solid #059d98;
}
.step-item strong {
  color: #059d98;
  font-weight: 600;
}
.btn-start-trial {
  background: #059d98;
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.btn-start-trial:hover {
  background: #059d98;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 153, 255, 0.4);
}
.results-section {
  max-width: 1200px;
  margin: 0 auto;
}
.title {
  color: #059d98;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 30px;
  line-height: 1.2;
}
.content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  align-items: center;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.text-content {
  padding: 60px 50px;
}
.stats-list {
  list-style: none;
  margin-bottom: 40px;
}
.stats-list li {
  color: #1a1a1a;
  font-size: 2rem;
  line-height: 1.6;
  margin-bottom: 25px;
  font-weight: 400;
}
.cta-button {
  background: #059d98;
  color: white;
  border: none;
  padding: 14px 32px;
  font-size: 1.5rem;
  font-weight: 600;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 119, 182, 0.3);
}
.cta-button:hover {
  background: #005a8d;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 119, 182, 0.4);
}
.image-content {
  height: 100%;
  position: relative;
  overflow: hidden;
}
.image-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
@media (max-width: 968px) {
  .content-wrapper {
    grid-template-columns: 1fr;
  }
  .text-content {
    padding: 40px 30px;
  }
  .title {
    font-size: 2rem;
  }
  .image-content {
    min-height: 400px;
  }
}
@media (max-width: 640px) {
  .text-content {
    padding: 30px 20px;
  }
  .title {
    font-size: 1.75rem;
    margin-bottom: 30px;
  }
  .stats-list li {
    font-size: 1rem;
    margin-bottom: 20px;
  }
  .image-content {
    min-height: 300px;
  }
}
.success-section {
  max-width: 1200px;
  margin: 0 auto;
}
.section-title {
  color: #059d98;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 40px;
  line-height: 1.2;
}
.story-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin-bottom: 30px;
}
.student-profile {
  display: flex;
  align-items: center;
  gap: 25px;
  margin-bottom: 30px;
}
.profile-image {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.profile-info {
  flex: 1;
}
.student-name {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}
.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #555;
  font-size: 1.5rem;
  margin-bottom: 6px;
}
.icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.story-content {
  background: #f8f9fa;
  border-radius: 15px;
  padding: 30px;
}
.story-title {
  font-size: 2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 20px;
}
.story-text {
  color: #333;
  font-size: 1.5rem;
  line-height: 1.8;
  margin-bottom: 20px;
}
.what-we-did {
  margin-bottom: 20px;
}
.what-we-did-title {
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 12px;
}
.action-list {
  list-style: none;
  padding-left: 0;
}
.action-list li {
  color: #333;
  font-size: 1.5rem;
  line-height: 1.7;
  margin-bottom: 8px;
  padding-left: 0;
}
.result-text {
  color: #333;
  font-size: 1.5rem;
  line-height: 1.8;
}
@media (max-width: 768px) {
  .section-title {
    font-size: 2rem;
  }
  .story-card {
    padding: 25px;
  }
  .student-profile {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  .profile-info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .info-item {
    justify-content: center;
  }
  .story-content {
    padding: 20px;
  }
  .story-title {
    font-size: 1.2rem;
  }
}
.rar-section {
  max-width: 1200px;
  margin: 0 auto;
}
.section-title {
  color: #059d98;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 40px;
  line-height: 1.2;
}
.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}
.feature-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.feature-image {
  width: 100%;
  height: 280px;
  object-fit: cover;
  display: block;
}
.feature-content {
  padding: 30px;
}
.feature-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 15px;
}
.feature-description {
  color: #555;
  font-size: 1.5rem;
  line-height: 1.7;
}
@media (max-width: 968px) {
  .features-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  .section-title {
    font-size: 2rem;
  }
  .feature-image {
    height: 240px;
  }
}
@media (max-width: 640px) {
  .section-title {
    font-size: 1.75rem;
    margin-bottom: 30px;
  }
  .feature-content {
    padding: 25px;
  }
  .feature-title {
    font-size: 1.2rem;
  }
  .feature-description {
    font-size: 0.95rem;
  }
  .feature-image {
    height: 200px;
  }
}
.programmes-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}
.programme-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  margin-bottom: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.main-title {
  color: #059d98;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 1.3;
}
.subtitle {
  color: #1a1a1a;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 20px;
}
.intro-text {
  color: #333;
  font-size: 1.5rem;
  line-height: 1.7;
  margin-bottom: 30px;
}
.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  margin-bottom: 30px;
}
.feature-box {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
}
.feature-box h4 {
  color: #1a1a1a;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 10px;
}
.feature-box p {
  color: #555;
  font-size: 1.5rem;
  line-height: 1.6;
}
.tabs-container {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}
.tab-buttons {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
  border-bottom: 2px solid #e0e0e0;
  flex-wrap: wrap;
}
.tab-button {
  background: none;
  border: none;
  padding: 15px 25px;
  font-size: 2rem;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
}
.tab-button:hover {
  color: #059d98;
}
.tab-button.active {
  color: #059d98;
  border-bottom-color: #059d98;
}
.tab-content {
  display: none;
}
.tab-content.active {
  display: block;
  animation: fadeIn 0.4s ease;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.program-title {
  color: #059d98;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 15px;
}
.program-subtitle {
  color: #1a1a1a;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 20px;
}
.description {
  color: #333;
  font-size: 1.5rem;
  line-height: 1.7;
  margin-bottom: 25px;
}
.section-heading {
  color: #1a1a1a;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 15px;
  margin-top: 20px;
}
.content-list {
  list-style: none;
  padding-left: 0;
}
.content-list li {
  color: #333;
  font-size: 1.5rem;
  line-height: 1.7;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
}
.content-list li:before {
  content: "\2022";
  position: absolute;
  left: 0;
  color: #059d98;
  font-weight: bold;
}
@media (max-width: 968px) {
  .feature-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .programme-card,
  .tabs-container {
    padding: 30px;
  }
  .main-title,
  .program-title {
    font-size: 1.5rem;
  }
  .tab-buttons {
    gap: 10px;
  }
  .tab-button {
    font-size: 1.1rem;
    padding: 12px 18px;
  }
}
@media (max-width: 640px) {
  .programmes-section {
    padding: 20px 15px;
  }
  .programme-card,
  .tabs-container {
    padding: 25px;
  }
  .main-title,
  .program-title {
    font-size: 1.3rem;
  }
  .section-heading {
    font-size: 1.1rem;
  }
  .tab-button {
    font-size: 1rem;
    padding: 10px 15px;
  }
  .subtitle,
  .program-subtitle {
    font-size: 1.3rem;
  }
  .intro-text,
  .description,
  .content-list li,
  .feature-box p {
    font-size: 1.1rem;
  }
  .feature-box h4 {
    font-size: 1.3rem;
  }
}
.uae-hero-container {
  width: 100%;
  height: 70%;
  margin: 0 auto;
}
.uae-hero-banner {
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(/assets/images/uae-new-bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 0;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 40px;
  position: relative;
}
.uae-content-box {
  text-align: center;
  max-width: 850px;
  color: white;
}
.uae-hero-title {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 25px;
  line-height: 1.2;
  letter-spacing: 1px;
  color: white;
}
.uae-promo-line {
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 15px;
  line-height: 1.5;
}
.uae-discount-badge {
  color: #FFD700;
  font-weight: 600;
}
.uae-info-text {
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 30px;
}
.uae-demo-btn {
  background: white;
  color: #00A8E8;
  border: none;
  padding: 14px 35px;
  font-size: 1.5rem;
  font-weight: 600;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-block;
}
.uae-demo-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
}
@media (max-width: 968px) {
  .uae-hero-banner {
    min-height: 350px;
    padding: 40px 30px;
  }
  .uae-hero-title {
    font-size: 2.2rem;
  }
  .uae-promo-line {
    font-size: 1.05rem;
  }
  .uae-info-text {
    font-size: 0.95rem;
  }
}
@media (max-width: 640px) {
  .uae-hero-banner {
    min-height: 300px;
    padding: 35px 20px;
  }
  .uae-hero-title {
    font-size: 1.75rem;
    margin-bottom: 20px;
  }
  .uae-promo-line {
    font-size: 0.95rem;
  }
  .uae-info-text {
    font-size: 0.9rem;
    margin-bottom: 25px;
  }
  .uae-demo-btn {
    padding: 12px 30px;
    font-size: 0.95rem;
  }
}
.pricing-main-container {
  max-width: 1200px;
  margin: 0 auto;
}
.pricing-header-title {
  color: #059d98;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 40px;
  line-height: 1.2;
}
.pricing-cards-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
}
.pricing-card-wrapper {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.pricing-card-header {
  background:
    linear-gradient(
      135deg,
      #FDB94E 0%,
      #F7A63C 100%);
  padding: 25px;
  text-align: center;
}
.pricing-plan-name {
  color: #1a1a1a;
  font-size: 32px;
  font-weight: 600;
  margin: 0;
}
.pricing-features-container {
  padding: 35px 30px;
  background: #f8f9fa;
}
.pricing-features-list {
  list-style: none;
  margin-bottom: 30px;
}
.pricing-feature-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #333;
  font-size: 1.5rem;
  line-height: 1.6;
  margin-bottom: 14px;
}
.pricing-check-icon {
  width: 20px;
  height: 20px;
  background: #059d98;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}
.pricing-check-icon::after {
  content: "\2713";
  color: white;
  font-size: 12px;
  font-weight: bold;
}
.pricing-cta-wrapper {
  display: flex;
  justify-content: center;
}
.pricing-book-button {
  background: #059d98;
  color: white;
  border: none;
  padding: 14px 40px;
  font-size: 1.5rem;
  font-weight: 600;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 119, 182, 0.3);
}
.pricing-book-button:hover {
  background: #005a8d;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 119, 182, 0.4);
}
@media (max-width: 968px) {
  .pricing-cards-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  .pricing-header-title {
    font-size: 2rem;
  }
}
@media (max-width: 640px) {
  .pricing-header-title {
    font-size: 1.75rem;
    margin-bottom: 30px;
  }
  .pricing-plan-name {
    font-size: 1.4rem;
  }
  .pricing-features-container {
    padding: 30px 25px;
  }
  .pricing-feature-item {
    font-size: 0.9rem;
  }
  .pricing-book-button {
    padding: 12px 35px;
    font-size: 0.95rem;
  }
}
.cta-outer-container {
  max-width: 1200px;
  margin: 0 auto;
}
.cta-banner-box {
  background:
    linear-gradient(
      135deg,
      #FDB94E 0%,
      #F7A63C 100%);
  border-radius: 15px;
  padding: 50px 40px;
  text-align: center;
}
.cta-main-heading {
  color: #059d98;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 30px;
  line-height: 1.2;
}
.cta-action-button {
  background: #059d98;
  color: white;
  border: none;
  padding: 16px 45px;
  font-size: 1.5rem;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 119, 182, 0.3);
  margin-bottom: 20px;
  display: inline-block;
}
.cta-action-button:hover {
  background: #005a8d;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 119, 182, 0.4);
}
.cta-subtext {
  color: #1a1a1a;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .cta-banner-box {
    padding: 40px 30px;
  }
  .cta-main-heading {
    font-size: 2rem;
    margin-bottom: 25px;
  }
  .cta-action-button {
    padding: 14px 40px;
    font-size: 1rem;
  }
  .cta-subtext {
    font-size: 1rem;
  }
}
@media (max-width: 640px) {
  .cta-banner-box {
    padding: 35px 25px;
    border-radius: 12px;
  }
  .cta-main-heading {
    font-size: 1.75rem;
    margin-bottom: 20px;
  }
  .cta-action-button {
    padding: 13px 35px;
    font-size: 0.95rem;
    margin-bottom: 18px;
  }
  .cta-subtext {
    font-size: 0.95rem;
  }
}
.about-sehyog-wrapper {
  background:
    linear-gradient(
      135deg,
      #059d98 0%,
      #00608a 100%);
  padding: 60px 40px;
}
.about-sehyog-content {
  max-width: 1200px;
  margin: 0 auto;
  color: white;
}
.about-main-title {
  color: #FDB94E;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 15px;
  line-height: 1.2;
}
.about-tagline {
  color: white;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 30px;
  line-height: 1.4;
}
.about-description-text {
  color: white;
  font-size: 1.5rem;
  line-height: 1.8;
  margin-bottom: 20px;
  font-weight: 400;
}
@media (max-width: 768px) {
  .about-sehyog-wrapper {
    padding: 50px 30px;
  }
  .about-main-title {
    font-size: 2rem;
  }
  .about-tagline {
    font-size: 1.1rem;
  }
  .about-description-text {
    font-size: 1rem;
  }
}
@media (max-width: 640px) {
  .about-sehyog-wrapper {
    padding: 40px 25px;
  }
  .about-main-title {
    font-size: 1.75rem;
    margin-bottom: 12px;
  }
  .about-tagline {
    font-size: 1rem;
    margin-bottom: 25px;
  }
  .about-description-text {
    font-size: 0.95rem;
    line-height: 1.7;
    margin-bottom: 18px;
  }
}
.newsletter-outer-wrapper {
  max-width: 1200px;
  margin: 0 auto;
}
.newsletter-bordered-box {
  background: white;
  border: 3px solid #059d98;
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
}
.newsletter-heading {
  color: #059d98;
  font-size: 4rem;
  font-weight: 600;
  margin-bottom: 35px;
  line-height: 1.3;
}
.newsletter-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
.newsletter-email-input {
  width: 100%;
  max-width: 400px;
  padding: 16px 25px;
  font-size: 2rem;
  border: 2px solid #ddd;
  border-radius: 30px;
  outline: none;
  transition: border-color 0.3s ease;
  font-family: inherit;
}
.newsletter-email-input:focus {
  border-color: #059d98;
}
.newsletter-email-input::placeholder {
  color: #666;
}
.newsletter-submit-btn {
  background: #059d98;
  color: white;
  border: none;
  padding: 16px 50px;
  font-size: 1.5rem;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 119, 182, 0.3);
}
.newsletter-submit-btn:hover {
  background: #005a8d;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 119, 182, 0.4);
}
@media (max-width: 768px) {
  .newsletter-bordered-box {
    padding: 50px 30px;
  }
  .newsletter-heading {
    font-size: 1.75rem;
    margin-bottom: 30px;
  }
  .newsletter-email-input {
    max-width: 100%;
  }
}
@media (max-width: 640px) {
  .newsletter-bordered-box {
    padding: 40px 25px;
    border-radius: 15px;
    border-width: 2px;
  }
  .newsletter-heading {
    font-size: 1.5rem;
    margin-bottom: 25px;
  }
  .newsletter-email-input {
    padding: 14px 20px;
    font-size: 0.95rem;
  }
  .newsletter-submit-btn {
    padding: 14px 40px;
    font-size: 1rem;
    width: 100%;
    max-width: 300px;
  }
}
.faq-container-main {
  max-width: 1200px;
  margin: 0 auto;
}
.faq-page-title {
  color: #059d98;
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 30px;
  line-height: 1.2;
}
.faq-accordion-item {
  background: white;
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.faq-question-header {
  background:
    linear-gradient(
      135deg,
      #FDB94E 0%,
      #F7A63C 100%);
  padding: 20px 25px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;
}
.faq-question-header:hover {
  background:
    linear-gradient(
      135deg,
      #F7A63C 0%,
      #FDB94E 100%);
}
.faq-question-text {
  color: #1a1a1a;
  font-size: 1.5rem;
  font-weight: 600;
  flex: 1;
}
.faq-toggle-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
  flex-shrink: 0;
  margin-left: 15px;
}
.faq-accordion-item.active .faq-toggle-icon {
  transform: rotate(180deg);
}
.faq-answer-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease;
}
.faq-accordion-item.active .faq-answer-content {
  max-height: 1500px;
}
.faq-answer-inner {
  padding: 25px;
  background: #f8f9fa;
  color: #333;
  font-size: 1.5rem;
  line-height: 1.8;
}
.faq-answer-inner p {
  margin-bottom: 15px;
}
.faq-answer-inner p:last-child {
  margin-bottom: 0;
}
.faq-answer-inner ul {
  margin: 10px 0 15px 20px;
  list-style: disc;
}
.faq-answer-inner li {
  margin-bottom: 8px;
  line-height: 1.7;
}
.faq-answer-inner strong {
  color: #1a1a1a;
  font-weight: 600;
}
@media (max-width: 768px) {
  .faq-page-title {
    font-size: 2rem;
  }
  .faq-question-header {
    padding: 18px 20px;
  }
  .faq-question-text {
    font-size: 1rem;
  }
  .faq-answer-inner {
    padding: 20px;
    font-size: 0.95rem;
  }
}
@media (max-width: 640px) {
  .faq-page-title {
    font-size: 1.75rem;
    margin-bottom: 25px;
  }
  .faq-question-header {
    padding: 16px 18px;
  }
  .faq-question-text {
    font-size: 0.95rem;
  }
  .faq-toggle-icon {
    width: 20px;
    height: 20px;
  }
  .faq-answer-inner {
    padding: 18px;
    font-size: 0.9rem;
  }
}
@media (max-width: 968px) {
  .hero-title {
    font-size: 36px;
  }
  .content-wrapper,
  .mission-wrapper,
  .values-wrapper,
  .learning-wrapper,
  .results-wrapper,
  .pricing-wrapper {
    flex-direction: column;
  }
  .features-grid {
    grid-template-columns: 1fr;
  }
  .courses-grid,
  .founding-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .hero-section {
    height: 500px;
  }
  .hero-title {
    font-size: 28px;
  }
  .hero-subtitle {
    font-size: 16px;
  }
  .section-title,
  .about-title,
  .mission-title,
  .values-title,
  .courses-title,
  .learning-title,
  .results-title,
  .pricing-title,
  .founding-title {
    font-size: 28px;
  }
  .why-choose-section,
  .about-section,
  .mission-section,
  .values-section,
  .courses-section,
  .learning-fits-section,
  .results-section,
  .pricing-section,
  .founding-batch-section {
    padding: 60px 0;
  }
  .btn-book-demo,
  .btn-join-batch {
    padding: 12px 30px;
    font-size: 14px;
  }
}
.text-center {
  text-align: center;
}
.mb-20 {
  margin-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
/*# sourceMappingURL=uae.component.css.map */
